import { Col, Container, Row } from 'react-bootstrap'
import KLayerNavigation from '../components/KLayerNavigation'
import { CheckoutForm } from '../components/Stripe'
import { isUserLoggedIn } from '../helpers'
import { t } from '../locale'
import ServiceOverviewTable from '../components/ServiceOverviewTable'
import { useSubscription } from '../context/SubscriptionContext'

function Company() {
  const { subscription, credit: subscriptionCredit } = useSubscription()

  return (
    <>
      <Container className='mb-5'>
        <Row>
          <div className='sidebar col-md-3 col-lg-2 p-0'>
            <KLayerNavigation logged={isUserLoggedIn()} />
          </div>
          <main className='col-md-9 ms-sm-auto col-lg-10 px-md-4'>
            <div className='text-center mb-12'>
              <h1>{t('buyCredits')}</h1>
              <div
                className='px-4 mt-4 bg-white sm:p-6 shadow sm:rounded-tl-md sm:rounded-tr-md text-start mx-auto'
                style={{ maxWidth: 900 }}
              >
                <ServiceOverviewTable />
              </div>
              {subscription && !subscription.isTrial && (
                <p className='text-lg text-muted mt-5 mb-2'>{t('choosePlan')}</p>
              )}
            </div>
            <Row className='row-cols-2 row-cols-md-4 g-2'>
              <Col>
                <p className='p-2 fw-bolder'>
                  {t('credits') + ': '} {subscriptionCredit}
                </p>
              </Col>
            </Row>
            <Row className=''>
              <div className='col-12 mb-3 mb-sm-0'>
                <div className='mt-2' id='checkout'>
                  <CheckoutForm />
                </div>
              </div>
            </Row>
          </main>
        </Row>
      </Container>
    </>
  )
}

export default Company
